export default {
        "logout-success": "Abmeldung erfolgreich",
        "logout-error": "Abmelden fehlgeschlagen",
        "confirm": "Bestätigen",
        "copySuccess": "Kopiert",
        "server": {
            "selectServer": "Server auswählen",
            "serverAmerica": "Amerika",
            "serverEurope": "Europa",
            "serverAsia": "Asien",
            "serverHMT": "HMT",
            "serverSEA": "SEA",
            "noRole": "Keine Charakter-Daten. \nBitte betreten Sie zuerst das Spiel.",
            "noRole2": "Keine Charakter-Daten",
            "noOtherRole": "Keine Charaktere gefunden, \nServerwechsel nicht möglich."
        },
        "uidlogin": { 
            "enterCode": "Bitte geben Sie den Code ein",
            "enterCode2": "Bitte geben Sie den richtigen Code ein",
            "sendCode": "Code senden",
            "agree": "Bitte lesen Sie und stimmen Sie den Nutzungsbedingungen und den Datenschutzrichtlinien zu",
            "sended": "Gesendet",
            "tipUid": "Bitte geben Sie die UID ein",
            "tipUid2": "Bitte geben Sie die richtige UID ein",
            "login": "Login",
            "loginFail": "Login fehlgeschlagen, bitte überprüfen Sie die UID und den Code",
            "loginSuccess": "Login erfolgreich",
            "sendFail": "Kein Rolle gefunden",
            "sendFail2": "Senden fehlgeschlagen",
            "sendFast": "Senden zu oft",
            "sendFast2": "Senden zu oft, bitte versuchen Sie es in {time} erneut",
            "codeInvaild": "Code abgelaufen"
        },
        "share-tips": "Lange drücken zum Speichern und Teilen"
};
